export default function mainVisual() {
  /**
   * メインビジュアル動画
   */
  (function ($) {
    // ホームでなければ処理をしない
    if ( ! $('body').hasClass('home') ) return;
    // Video JS HLS Config
    var overrideNative = true;

    var options = {
      aspectRatio: '16:9',
      fill: true,
      muted: false,
      preload: true,
      autoplay: false,
      loop: true,
      controls: false,
      errorDisplay: false,
      html5: {
        vhs: {
          withCredentials: true,
          overrideNative: overrideNative
        },
        nativeVideoTracks: !overrideNative,
        nativeAudioTracks: !overrideNative,
        nativeTextTracks: !overrideNative
      }
    };

    // メインビジュアルの1つ目の動画はオートプレイをON
    options.autoplay = false;

    // Video 1
    var mainVisualVideo = videojs('main-visual-video', options, function () {
      detectMainVisualHide();
      return false;
    });

    $('#mainvisualVideo').find('.mainVisual--sliderAudioButton-on').on('click', function () {
      if (true === mainVisualVideo.muted()) {
        mainVisualVideo.muted(false);
        $(this).addClass('is-active');
        $('#mainvisualVideo').find('.mainVisual--sliderAudioButton-off').removeClass('is-active');
      }
    });
    $('#mainvisualVideo').find('.mainVisual--sliderAudioButton-off').on('click', function () {
      if (false === mainVisualVideo.muted()) {
        mainVisualVideo.muted(true);
        $(this).addClass('is-active');
        $('#mainvisualVideo').find('.mainVisual--sliderAudioButton-on').removeClass('is-active');
      }
    });

    $('#mainvisualVideo').find('#mainVisualVideoPlayPause').on('click', function () {
      if (true === mainVisualVideo.paused()) {
        mainVisualVideo.play();
        $(this).addClass('is-pause-icon');
        $(this).removeClass('is-play-icon');
      } else {
        mainVisualVideo.pause();
        $(this).addClass('is-play-icon');
        $(this).removeClass('is-pause-icon');
      }
    });

    mainVisualVideo.on('play', function () {
      console.log("play");
    });

    mainVisualVideo.on('paused', function () {
      console.log("paused");
    });

    function detectMainVisualHide() {
      if ($('body').hasClass('home')) {
        let $nav = $("#mainNavigationBg");
        let fadeMsec = 500;
        $(window).scroll(function() {
          if ($(this).scrollTop() > 400) {
            $nav.addClass('is-white');
          } else {
            $nav.removeClass('is-white');
          }
        });

        $('.main-navigation')
          // マウスポインターが画像に乗った時の動作
          .mouseover(function(e) {
            $nav.addClass('is-white');
          })
          // マウスポインターが画像から外れた時の動作
          .mouseout(function(e) {
            $nav.removeClass('is-white');
          });
        // // 変化させる要素
        // var elem = $("#mainVisualWrapper");
        // // ページトップからの要素の高さ
        // var elemO = elem.offset().top;
        // // 変化させる要素の高さ
        // var elemH = elem.height();
        // // ウィンドウの高さ
        // var windowH = $(window).height();

        // $(window).on("scroll", function() {
        //   // スクロールした値
        //   var windowS = $(window).scrollTop();

        //   // 要素が半分見えたら表示して、要素がウィンドウから半分消えたら非表示にする
        //   if(windowS > elemO - windowH + (windowH / 2) && windowS < elemO + elemH - (elemH / 2)){
        //     $(".main-navigation").addClass('is-white');
        //   } else {
        //     $(".main-navigation").removeClass('is-white');
        //   }

        // });
      }
    }
  })(jQuery);
}
